import React from 'react';
import { Box, Stack } from '@chakra-ui/react';
import { FiArrowLeft } from 'react-icons/fi';
import { NavDropdownItem, TOP_FEATURES_ITEMS, LEARN_MORE_ITEMS } from '../navigationData';

interface MobileSubmenuProps {
  activeMenu: 'top-features' | 'learn-more' | null;
  onBack: () => void;
  onCloseDrawer: () => void;
}

const MobileSubmenu: React.FC<MobileSubmenuProps> = ({ activeMenu, onBack, onCloseDrawer }) => {
  const isVisible = activeMenu !== null;

  const getItems = (): NavDropdownItem[] => {
    if (activeMenu === 'top-features') return TOP_FEATURES_ITEMS;
    if (activeMenu === 'learn-more') return [LEARN_MORE_ITEMS[0]];
    return [];
  };

  const items = getItems();
  const gradientId = activeMenu === 'top-features' ? 'gradient-purple-pink' : 'gradient-indigo-teal';
  const title = activeMenu === 'top-features' ? 'Top Features' : 'Learn More';

  return (
    <Box
      py={6}
      px={4}
      transition="all 0.3s ease"
      transform={isVisible ? 'translateX(0)' : 'translateX(100%)'}
      opacity={isVisible ? 1 : 0}
      position={isVisible ? 'relative' : 'absolute'}
      width="100%"
      top={0}
      left={0}
      role="menu"
      aria-label={`${title} submenu`}
    >
      <Box
        as="button"
        onClick={onBack}
        display="flex"
        alignItems="center"
        gap={2}
        mb={4}
        p={2}
        color="gray.600"
        _hover={{ color: '#13131B' }}
        transition="color 0.2s ease"
        aria-label="Go back to main menu"
      >
        <FiArrowLeft size={18} aria-hidden="true" />
        <Box fontFamily="lato" fontWeight="bold" fontSize="0.9rem">
          Back
        </Box>
      </Box>

      <Box
        as="h2"
        fontFamily="lato"
        fontWeight="bold"
        fontSize="1.25rem"
        color="#13131B"
        mb={4}
        px={2}
      >
        {title}
      </Box>

      {isVisible && (
        <Stack gap={1} as="ul" listStyleType="none">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <Box as="li" key={item.href} role="menuitem">
                <a
                  href={item.href}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    fontFamily: 'lato',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    color: '#13131B',
                    padding: '12px 8px',
                    borderRadius: '12px',
                  }}
                  onClick={onCloseDrawer}
                >
                  <span
                    className="submenu-icon"
                    style={{ flexShrink: 0 }}
                    data-gradient={gradientId}
                    aria-hidden="true"
                  >
                    <Icon size={24} />
                  </span>
                  <Box>
                    <Box>{item.title}</Box>
                    <Box fontWeight="normal" fontSize="0.8rem" color="gray.500" mt={0.5}>
                      {item.description}
                    </Box>
                  </Box>
                </a>
              </Box>
            );
          })}
        </Stack>
      )}
    </Box>
  );
};

export default MobileSubmenu;
